/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum AccountSubscriptionType {
    NONE = 'None',
    STANDARD = 'Standard',
    ENHANCED = 'Enhanced',
    ULTIMATE = 'Ultimate',
    ULTIMATE_PLUS = 'UltimatePlus',
}
